import { render, staticRenderFns } from "./PositionsDialog.vue?vue&type=template&id=5afa0fb6&scoped=true"
import script from "./PositionsDialog.vue?vue&type=script&lang=js"
export * from "./PositionsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5afa0fb6",
  null
  
)

export default component.exports